import React from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade';

type IProps =React.PropsWithChildren

export const Title = (props: IProps) => {
  return (
    <Fade left cascade duration={500} distance="40px">
      <h2 className="title">
        <p className="title__label" translate='no'>{props.children}</p>
        <div className="title__underline" />
      </h2>
    </Fade>
  )
}